import React, { useRef, useEffect } from "react";
import { StepInputModel } from '../../../models/step-input.model';

interface Props extends StepInputModel {
    onFocus: () => void;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onKeyUp: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => void;
    onBlur: () => void;
    setWidth?: string;
    index: number;
    OtpTextFieldColor?: string;
}

const StepInput: React.FC<Props> = (props) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const { focus } = props;
        if (inputRef.current) {
            if (focus) {
                inputRef.current.focus();
            }
        }
    }, [props.focus]);

    const {
        disabled,
        setWidth,
        index,
        OtpTextFieldColor,
        numOfSteps,
        stepLength,
    } = props;

    return (
        <input
            data-arrow-index={index + 1}
            data-up-arrow-index={numOfSteps + 3}
            data-down-arrow-index={numOfSteps + 1}
            ref={inputRef}
            tabIndex={index + 1}
            autoFocus={props.focus}
            onFocus={props.onFocus}
            onChange={props.onChange}
            onKeyUp={props.onKeyUp}
            onBlur={props.onBlur}
            onPaste={props.onPaste}
            disabled={disabled}
            className={`otp-boxes color-auth-field-focus ${OtpTextFieldColor} ${setWidth}`}
            maxLength={stepLength}
            type="text"
            inputMode='numeric'
            onInput={(e) => (e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, ''))}
        />
    );
};

export default StepInput;
